import RIcon from "./ReservasIcons";
import { SucursalesChip } from "./Sucursales";
import { RatingBadge } from "./RatingStars";
import { normalizeNearbySlots } from "./quickReservationModel";
const FALLBACK_IMAGE = "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1200&q=80";
const cityName = (bar) => typeof bar?.cityid === "string" ? bar.cityid : bar?.cityid?.name || "";
const price = (bar) => bar?.depositAmount > 0 ? `$${Number(bar.depositAmount).toLocaleString("es-AR")}` : "$0";
export default function BarCard({ bar, showQuickSlots, onNavigate, onSelectSlot }) {
  const slugOrId = bar.slug || bar._id;
  const slots = showQuickSlots ? normalizeNearbySlots(bar.nearbySlots) : [];
  const navigate = () => onNavigate(slugOrId);
  return (
    <div className="bar-card" onClick={navigate}>
      <div className="bar-media">
        <img src={bar.image || bar.mobileimage || FALLBACK_IMAGE} alt={bar.name || "Bar"}
          onError={(event) => { event.currentTarget.src = FALLBACK_IMAGE; }} />
        <div className="bar-media-deposit"><span className="deposit-label">Seña</span><span className="deposit-val">{price(bar)}</span></div>
      </div>
      <div className="bar-body">
        <div className="bar-name">{bar.name}</div>
        <SucursalesChip count={bar.sucursalesCount} />
        <div className="bar-loc"><RIcon name="pin" width={14} height={14} />{[cityName(bar), bar.address].filter(Boolean).join(" · ")}</div>
        {Number(bar.ratingCount) > 0 && <div className="rv-card-rating"><RatingBadge avg={bar.ratingAvg} count={bar.ratingCount} /></div>}
        {Array.isArray(bar.amenities) && <div className="bar-tags">{bar.amenities.slice(0, 2).map((tag) => <span className="bar-tag" key={tag}>{tag}</span>)}</div>}
        {slots.length > 0 && <div className="quick-table-slots" aria-label={`Horarios cercanos para ${bar.name}`}>
          {slots.map((slot) => <button type="button" key={slot.slotStart}
            aria-label={`Reservar ${bar.name} a las ${slot.slotStart}`}
            onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") event.stopPropagation(); }}
            onClick={(event) => { event.stopPropagation(); onSelectSlot?.(bar, slot, event.currentTarget); }}>{slot.slotStart}</button>)}
        </div>}
        <div className="bar-foot centered"><button type="button" className="r-btn-primary bar-action-btn"
          onClick={(event) => { event.stopPropagation(); navigate(); }}>Ver mesas</button></div>
      </div>
    </div>
  );
}
